'use strict';

require('../../../modules/es.function.bind');
var getBuiltInPrototypeMethod = require('../../../internals/get-built-in-prototype-method');
module.exports = getBuiltInPrototypeMethod('Function', 'bind');